module.exports = __webpack_public_path__ + "img/icon-energy-multimedia.548aa8f9.svg";